<template>
  <div class="c-table" ref="developerConfigTable">
    <el-table class="common-el-table-styles" v-loading="loading" :data="data" :height="height" border stripe>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'control'">
            <el-button type="text" size="small" @click="$emit('on-edit', scope.row)">编辑</el-button>
          </div>
          <span v-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'
export default {
  name: 'developerConfigTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    }
  },
  data() {
    return {
      height: 0
    }
  },
  mounted() {
    this.$nextTick(() => {
      timeout(0).then(() => {
        this.$refs.developerConfigTable && (this.height = this.$refs.developerConfigTable.offsetHeight - 7)
      })
    })
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  height: calc(100% - 32px);
}
</style>
